import { render, staticRenderFns } from "./dashMenu.vue?vue&type=template&id=133b75af&scoped=true&"
import script from "./dashMenu.vue?vue&type=script&lang=js&"
export * from "./dashMenu.vue?vue&type=script&lang=js&"
import style0 from "./dashMenu.vue?vue&type=style&index=0&id=133b75af&scoped=true&lang=css&"
import style1 from "~/components/nav/loggedIn/navBaseElem.css?vue&type=style&index=1&id=133b75af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b75af",
  null
  
)

export default component.exports